import * as xhr from "utils/xhr";
import AutoSuggestContainer from "autosuggest-container.class";
import {
    simulateKeydownEvent
} from "autosuggest-helpers";

class AutoSuggest {
    constructor(el) {
        this.inputElement = el.parentNode.querySelector('input.inp-text');
        this.requestUrl = el.dataset.requestUrl;
        this.container = new AutoSuggestContainer(el, this.inputElement);

        for (let type of ['keyup', 'keydown', 'focusout']) {
            this.inputElement.addEventListener(type, this);
        }
    }

    /**
     * buildRequestUrl
     * @returns {string} url
     */
    buildRequestUrl() {
        let queryIndicator = this.requestUrl.indexOf('?') !== -1 ? '&' : '?';
        return `${this.requestUrl}${queryIndicator}tx_solr[queryString]=${this.inputElement.value}&tx_solr[callback]=`;
    }

    /**
     * handleEvent
     * @param {object} event 
     */
    handleEvent(event) {
        switch (event.type) {
            case "keydown":
                if (event.key == "ArrowDown") {
                    event.preventDefault();
                    this.container.preventFocusOutEvent = true;
                    this.container.node.firstChild.querySelector('a').focus();
                    simulateKeydownEvent("tab", this.inputElement);
                } else {
                    if (event.key == "Tab") {
                        if (this.container.node.hasChildNodes()) {
                            this.container.preventFocusOutEvent = true;
                            this.container.node.firstChild.focus();
                        }
                    }
                }
                break;

            case "keyup":
                this.inputElement.value.length >= 3 ? this.request() : this.container.reset();
                break;

            case "focusout":
                this.container.reset();
                break;
        }
    }

    /**
     * handleResponse
     */
    handleResponse() {
        if (Object.keys(this.suggestions).length > 0) {
            this.populate();
        } else {
            this.container.reset();
        }
    }

    /**
     * populate
     */
    populate() {
        this.container.show();
        for (let text in this.suggestions) {
            this.container.append(text);
        }
    }

    /**
     * request
     */
    request() {
        let _this = this;

        xhr.get(this.buildRequestUrl()).then(function (res) {
            let parsedResult = res.substring(0, 1) == '(' ? JSON.parse(res.substring(1, res.length - 1)) : JSON.parse(res);
            _this.suggestions = parsedResult.suggestions;
            _this.handleResponse();
        });
    }
}

export default AutoSuggest;